import { FRStep } from '@forgerock/javascript-sdk/lib-esm';

export class FrRealmSteps {
  authId: string;
  steps: FRStep[];

  constructor() {
    this.steps = [];
  }
}
